import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
const CHECKOUT_LINKS: Record<1 | 2, string> = {
  1: 'https://checkout.tusbeneficios.shop/cart/51457664516329:1',
  2: 'https://checkout.tusbeneficios.shop/cart/51457665040617:1'
};
export function Pricing() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const [selectedPlan, setSelectedPlan] = useState<1 | 2>(2);
  const handleCheckout = () => {
    window.location.href = CHECKOUT_LINKS[selectedPlan];
  };
  return <section id="pricing-section" className="bg-brand-dark py-16 px-4 sm:px-6 lg:px-8" data-id="element-159">
      <div className="max-w-xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-161">
          <h3 className="text-gray-400 font-bold tracking-widest text-sm mb-4" data-id="element-162">
            🕐 ESTA OFERTA TERMINA EN
          </h3>
          <div className="flex justify-center gap-4 mb-10" data-id="element-163">
            {[{
            value: hours,
            label: 'HORAS'
          }, {
            value: minutes,
            label: 'MIN'
          }, {
            value: seconds,
            label: 'SEG'
          }].map((time, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-164">
                <div className="bg-brand-darker border border-white/10 rounded-xl w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center text-3xl sm:text-4xl font-bold text-white mb-2 shadow-inner" data-id="element-165">
                  {time.value}
                </div>
                <span className="text-xs text-gray-500 font-semibold" data-id="element-166">
                  {time.label}
                </span>
              </div>)}
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2" data-id="element-167">
            ELEGÍ TU BIOKIT UNIVERSITARIO
          </h2>
          <p className="text-brand-tealLight text-sm font-medium" data-id="element-168">
            Ambas opciones incluyen los 6 tomos completos
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-169">
          {/* Plan 1 */}
          <div onClick={() => setSelectedPlan(1)} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all ${selectedPlan === 1 ? 'border-brand-teal bg-brand-darker' : 'border-white/10 bg-brand-dark hover:border-white/30'}`} data-id="element-170">
            <div className="flex items-start gap-4" data-id="element-171">
              <div className={`mt-1 w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selectedPlan === 1 ? 'border-brand-teal' : 'border-gray-500'}`} data-id="element-172">
                {selectedPlan === 1 && <div className="w-2.5 h-2.5 rounded-full bg-brand-teal" data-id="element-173" />}
              </div>
              <div className="flex-1" data-id="element-174">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-175">
                  🧪 BIOKIT UNIVERSITARIO
                </h3>
                <p className="text-gray-400 text-sm mb-3" data-id="element-176">
                  6 tomos + 4 bonos esenciales
                </p>
                <div className="flex items-center gap-2" data-id="element-177">
                  <span className="text-gray-500 line-through text-sm" data-id="element-178">
                    $29.990
                  </span>
                  <span className="text-white font-bold text-xl" data-id="element-179">$19.990</span>
                </div>
              </div>
            </div>
          </div>

          {/* Plan 2 */}
          <div onClick={() => setSelectedPlan(2)} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all relative overflow-hidden ${selectedPlan === 2 ? 'border-brand-teal bg-brand-darker' : 'border-white/10 bg-brand-dark hover:border-white/30'}`} data-id="element-180">
            {selectedPlan === 2 && <div className="absolute top-0 right-0 bg-brand-teal/10 w-32 h-32 rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none" data-id="element-181" />}
            <div className="flex items-start gap-4 relative z-10" data-id="element-182">
              <div className={`mt-1 w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selectedPlan === 2 ? 'border-brand-teal' : 'border-gray-500'}`} data-id="element-183">
                {selectedPlan === 2 && <div className="w-2.5 h-2.5 rounded-full bg-brand-teal" data-id="element-184" />}
              </div>
              <div className="flex-1" data-id="element-185">
                <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-186">
                  <h3 className="text-white font-bold text-lg" data-id="element-187">
                    🚀 BIOKIT + EXTRAS
                  </h3>
                  <span className="bg-brand-teal text-white text-[10px] font-bold px-2 py-0.5 rounded-sm" data-id="element-188">
                    ⭐ MÁS ELEGIDO
                  </span>
                </div>
                <p className="text-gray-400 text-sm mb-3" data-id="element-189">
                  6 tomos + 7 bonos (4 esenciales + 3 adicionales)
                </p>
                <div className="flex items-center gap-3" data-id="element-190">
                  <div className="flex items-center gap-2" data-id="element-191">
                    <span className="text-gray-500 line-through text-sm" data-id="element-192">
                      $43.990
                    </span>
                    <span className="text-white font-bold text-xl" data-id="element-193">
                      $27.990
                    </span>
                  </div>
                  <span className="bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-sm" data-id="element-194">
                    AHORRÁS $16.000
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <motion.div whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-195">
          <button onClick={handleCheckout} className="w-full h-[56px] bg-brand-teal text-white font-bold rounded-xl text-lg shadow-lg hover:bg-brand-tealLight transition-all flex items-center justify-center gap-2 mb-3" data-id="element-196">
            SÍ, QUIERO EL BIOKIT + EXTRAS →
          </button>
        </motion.div>

        <p className="text-center text-gray-400 text-xs mb-6" data-id="element-197">
          La opción más elegida por quienes quieren llegar organizados a fin de
          año
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs text-gray-400 font-medium" data-id="element-198">
          <span className="flex items-center gap-1" data-id="element-199">🔒 Pago seguro</span>
          <span data-id="element-200">·</span>
          <span className="flex items-center gap-1" data-id="element-201">⚡ Acceso inmediato</span>
          <span data-id="element-202">·</span>
          <span className="flex items-center gap-1" data-id="element-203">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}